import { useTranslation } from 'react-i18next';

export const PAGE_SIZE = 50;

export function Pager({
  offset,
  total,
  onChange,
}: {
  offset: number;
  total: number;
  onChange: (offset: number) => void;
}) {
  const { t } = useTranslation();
  if (total === 0) return null;
  const from = offset + 1;
  const to = Math.min(offset + PAGE_SIZE, total);
  return (
    <div className="mt-3 flex items-center justify-between text-sm text-stone-500">
      <span>{t('common.pageOf', { from, to, total })}</span>
      <div className="flex gap-2">
        <button
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - PAGE_SIZE))}
          className="rounded-md border border-stone-300 bg-white px-3 py-1.5 hover:bg-stone-50 disabled:opacity-40"
        >
          {t('common.prev')}
        </button>
        <button
          disabled={to >= total}
          onClick={() => onChange(offset + PAGE_SIZE)}
          className="rounded-md border border-stone-300 bg-white px-3 py-1.5 hover:bg-stone-50 disabled:opacity-40"
        >
          {t('common.next')}
        </button>
      </div>
    </div>
  );
}
